<div class="empty-state">
  <img src="/assets/img/empty-state-tacho.svg" class="image" />

  <span class="title">
    {{'labels.no-data'|translate}}
  </span>

  <span class="description">
    {{ desc }}
  </span>
</div>
